import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  const bullets = ['Si compras leads de Zillow o Realtor.com que ya recibieron llamadas de 10 agentes antes que tú', 'Si tu base de datos de contactos está dormida y no sabes cómo reactivarla', 'Si tus anuncios de Facebook atraen curiosos que no tienen pre-aprobación bancaria', 'Si dependes de tu esfera personal para conseguir transacciones y ya la agotaste', 'Si ves a otros agentes cerrando 5 transacciones al mes mientras tú luchas por 1 o 2'];
  return <section className="relative min-h-screen flex items-center pt-20 pb-24 overflow-hidden" data-id="element-216">
      {/* Background Image & Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-217">
        <img src="https://cdn.magicpatterns.com/uploads/1LT7C2pYgs8z2vR7mq5Fbp/heylloyd-image-1773437439605.png" alt="Agente de Real Estate mostrando propiedad" className="w-full h-full object-cover object-top" data-id="element-218" />
        <div className="absolute inset-0 bg-carbon/90 md:bg-gradient-to-r md:from-carbon/95 md:via-carbon/80 md:to-carbon/40" data-id="element-219" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 w-full relative z-10" data-id="element-220">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center md:items-start text-center md:text-left max-w-3xl relative" data-id="element-221">
          {/* Vertical Gold Accent Line (Desktop) */}
          <div className="hidden md:block absolute -left-8 top-2 h-32 w-[2px] bg-gold/40" data-id="element-222" />

          <motion.h1 variants={itemVariants} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-gold leading-[0.95] tracking-tight mb-6 md:mb-8" data-id="element-223">
            ¿Persiguiendo leads fríos que no tienen pre-aprobación ni intención
            real de comprar?
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-300 mb-10 md:mb-12 max-w-2xl leading-relaxed" data-id="element-224">
            Implementamos el{' '}
            <span className="text-white font-bold" data-id="element-225">Sistema A.C.E.™</span> para
            Agentes de Real Estate: el protocolo que atrae compradores y
            vendedores calificados que están listos para actuar en los próximos
            30 a 90 días.
          </motion.p>

          <motion.ul variants={itemVariants} className="space-y-4 md:space-y-5 mb-12 md:mb-14 w-full" data-id="element-226">
            {bullets.map((bullet, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3 text-left" data-id="element-227">
                <AlertTriangleIcon className="w-5 h-5 md:w-6 md:h-6 text-red-500 shrink-0 mt-0.5" data-id="element-228" />
                <span className="text-gray-300 text-base md:text-lg leading-snug" data-id="element-229">
                  {bullet}
                </span>
              </motion.li>)}
          </motion.ul>

          <motion.div variants={itemVariants} className="w-full sm:w-auto flex flex-col items-center md:items-start" data-id="element-230">
            <Button onClick={scrollToContact} className="w-full sm:w-auto" data-id="element-231">
              QUIERO LEADS DE COMPRADORES CALIFICADOS
            </Button>
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="mt-5 text-gold/70 text-sm md:text-base underline hover:text-gold transition-colors font-medium tracking-wide" data-id="element-232">
              O agenda directamente →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}